import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["refreshIndicator"]

  connect() {
    console.log("Boards controller connected")
    this.loadData()
    this.startRefreshTimer()
    this.setupRefreshIndicator()
  }

  setupRefreshIndicator() {
    this.refreshIndicator = document.querySelector('.auto-refresh-indicator')

    if (this.refreshIndicator) {
      this.refreshIndicator.setAttribute('data-auto-refresh-active', 'true')
    }
  }

  disconnect() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  startRefreshTimer() {
    this.refreshTimer = setInterval(() => {
      this.loadData()
      console.log('Dashboard refreshed at', new Date().toLocaleTimeString())
    }, 10000)
  }

  loadData() {
    this.fetchApplicants()
    this.updateMetrics()

    if (this.refreshIndicator) {
      this.refreshIndicator.classList.add('refreshing')
      setTimeout(() => {
        this.refreshIndicator.classList.remove('refreshing')
      }, 1000)
    }
  }

  fetchApplicants() {
    fetch('/boards/refresh_applicants', {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .catch(error => {
      console.error('Error fetching applicants:', error)
    })
  }

  updateMetrics() {
    fetch('/boards/update_metrics', {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .catch(error => {
      console.error('Error updating metrics:', error)
    })
  }
}
